import { XMarkIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

type BannerProps = {
  text: string;
  textMobile?: string;
};
const TopBanner = ({ text, textMobile = text }: BannerProps) => {
  const [shown, setShown] = useState(true);

  return (
    <>
      {shown && (
        <div className="relative bg-primary-600">
          <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
            <div className="pr-16 sm:text-center sm:px-16">
              <p className="font-medium text-white">
                <span className="md:hidden">{textMobile}</span>
                <span className="hidden md:inline">{text}</span>
              </p>
            </div>
            <div className="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start">
              <button
                type="button"
                onClick={() => setShown(false)}
                className="flex p-2 rounded-md hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-white"
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default TopBanner;
